import React, { useCallback } from "react";
import { Container } from "@mui/material";
import DivesiteDetails from "./divesitedetails";

const DivesiteItem = ({ divesite, isLast, refProp }) => {
  return (
    <Container>
      <DivesiteDetails divesite={divesite} />
      {isLast && <div ref={refProp}></div>}
    </Container>
  );
};

export default React.memo(DivesiteItem);
